
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function InstantImpact() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        {/* Title */}
        <h2
          className="text-center text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-14 leading-snug max-w-3xl mx-auto"
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          {t('impact.title')}
        </h2>

        {/* Two Cards */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mb-12">
          {/* Card 1 — Current System (Red/Negative) */}
          <div className="relative rounded-2xl border-2 border-red-200 bg-red-50/60 p-8 flex flex-col items-center text-center transition-all hover:shadow-lg hover:-translate-y-1 duration-300">
            {/* Icon */}
            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-red-100 mb-6">
              <i className="ri-delete-bin-line text-red-500 text-3xl"></i>
            </div>
            {/* Badge */}
            <span
              className="inline-block px-4 py-1.5 rounded-full bg-red-500 text-white text-xs font-semibold tracking-wide uppercase mb-5"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {t('impact.card1Badge')}
            </span>
            {/* Text */}
            <p
              className="text-gray-700 text-sm sm:text-base leading-relaxed"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              <strong className="text-red-600">{t('impact.card1Highlight')}</strong>
              <br />
              {t('impact.card1Text')}
            </p>
          </div>

          {/* Card 2 — ABRS Solution (Green/Positive) */}
          <div className="relative rounded-2xl border-2 border-emerald-200 bg-emerald-50/60 p-8 flex flex-col items-center text-center transition-all hover:shadow-lg hover:-translate-y-1 duration-300">
            {/* Icon */}
            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-emerald-100 mb-6">
              <i className="ri-tools-line text-emerald-600 text-3xl"></i>
            </div>
            {/* Badge */}
            <span
              className="inline-block px-4 py-1.5 rounded-full bg-emerald-500 text-white text-xs font-semibold tracking-wide uppercase mb-5"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {t('impact.card2Badge')}
            </span>
            {/* Text */}
            <p
              className="text-gray-700 text-sm sm:text-base leading-relaxed"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              <strong className="text-emerald-600">{t('impact.card2Highlight')}</strong>
              <br />
              {t('impact.card2Text')}
            </p>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-white rounded-2xl font-semibold text-base hover:shadow-xl hover:shadow-[#FF6B6B]/25 transition-all cursor-pointer whitespace-nowrap"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {t('impact.cta')}
            <i className="ri-calculator-line text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
